import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const VISITOR_KEY = "dosoft.visitor_id";

function getVisitorId() {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) {
    v = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, v);
  }
  return v;
}

/**
 * Fires a page-view event on every route change.
 * Skips /admin/* paths and bot user agents (server also filters).
 */
export function usePageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin")) return;
    const visitor_id = getVisitorId();
    const referrer = document.referrer || null;
    // Fire-and-forget; ignore network errors.
    api.post("/track/view", { visitor_id, path: pathname, referrer }).catch(() => {});
  }, [pathname]);
}
